<template>
  <div class="container">
    <v-row>
      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.mobile ? 'text-center' : ''"
      >
        <div
          class="mt-10 font-weight-medium grey--text text--darken-3"
          :class="$vuetify.breakpoint.mobile ? 'text-h6' : 'text-h5'"
        >
          Einblicke in das Vereinsgeschehen
        </div>
        <div class="mt-1">
          Aktuelle Berichte aus Abteilungen, Angeboten, Workshops und Events.
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="blogPosts.length > 0"
      class="mt-5"
      style="box-sizing: border-box"
    >
      <v-col
        class="pa-2 py-3"
        v-for="(post, i) in blogPosts"
        :key="i"
        cols="12"
        :md="i === 0 || i === 5 ? 8 : 4"
      >
        <BlogPost maxHeight="500" :post="post" />
      </v-col>
    </v-row>
    <div v-else class="grey--text text-center mt-16">
      <v-divider></v-divider>
      <v-divider></v-divider>
      {{ $t("no_data_loaded") }}
      <v-divider></v-divider>
      <v-divider></v-divider>
    </div>
    <v-row justify="center">
      <v-col cols="8">
        <v-container class="max-width">
          <v-pagination
            v-model="page"
            @click="page = value"
            class="my-4"
            :length="getPostsAmount()"
          ></v-pagination>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BlogPost from "@/components/BlogPost";
export default {
  components: {
    BlogPost,
  },
  computed: {
    blogPosts() {
      return this.$store.getters["publicApi/getBlogPosts"];
    },
    postsAmount() {
      return this.$store.getters["publicApi/getPostsAmount"];
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  created() {
    if (this.$store.getters["publicApi/getBlogPosts"].length === 0) {
      this.$store.dispatch("publicApi/getBlogPosts", this.page);
    }
    this.$store.dispatch("publicApi/getBlogPostCount");
  },
  methods: {
    getPostsAmount() {
      return Math.ceil(this.postsAmount / 7);
    },
  },
  watch: {
    page(value) {
      this.$store.dispatch("publicApi/getBlogPosts", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";
* {
  box-sizing: border-box;
}
</style>
